import type { CrusherJawCJInfoDataInterface } from './CrusherJawCJTypes';

/**
 * Returns motor power of a specific jaw crusher model
 * @param modelName Name of Jaw Crusher model
 */
export const getMotorPower = (
  modelName: string,
  unitInfoData: CrusherJawCJInfoDataInterface,
): number => {
  return unitInfoData[modelName].motorPower;
};

/**
 * Gets the max feed size for the selected jaw crusher
 * @param modelName Name of Jaw Crusher model
 */
export const getMaxFeed = (
  modelName: string,
  unitInfoData: CrusherJawCJInfoDataInterface,
): number => {
  return unitInfoData[modelName].maxFeed;
};

/**
 * Gets the feed open height for the selected jaw crusher
 * @param modelName Name of Jaw Crusher model
 */
export const getFeedOpenHeight = (
  modelName: string,
  unitInfoData: CrusherJawCJInfoDataInterface,
): number => {
  return unitInfoData[modelName].feedOpenHeight;
};

/**
 * Gets the feed open width for the selected jaw crusher
 * @param modelName Name of Jaw Crusher model
 */
export const getFeedOpenWidth = (
  modelName: string,
  unitInfoData: CrusherJawCJInfoDataInterface,
): number => {
  return unitInfoData[modelName].feedOpenWidth;
};

/**
 * Gets the lower css limit for the selected jaw crusher
 * @param modelName Name of Jaw Crusher model
 */
export const getLowerCSSLimit = (
  modelName: string,
  unitInfoData: CrusherJawCJInfoDataInterface,
): number => {
  return unitInfoData[modelName].lowerCSS;
};

/**
 * Gets the upper css limit for the selected jaw crusher
 * @param modelName Name of Jaw Crusher model
 */
export const getUpperCSSLimit = (
  modelName: string,
  unitInfoData: CrusherJawCJInfoDataInterface,
): number => {
  return unitInfoData[modelName].upperCSS;
};

/**
 * Calculates the nominal capacity for the selected jaw crusher
 * @param modelName Name of Jaw Crusher model
 * @param css Selected CSS for Jaw Crusher
 */
export const getNominalCapacity = (
  modelName: string,
  css: number | undefined,
  unitInfoData: CrusherJawCJInfoDataInterface,
): number | undefined => {
  if (css) {
    return Math.round(
      unitInfoData[modelName].capacityConstant * css +
        unitInfoData[modelName].capacityOffset,
    );
  }
};
